import React, { Component } from 'react'
import { bool, func, string } from 'prop-types'
import Modal from 'react-modal'
import { translate } from 'react-i18next'

class SelectGardenerModalComponent extends Component {
  constructor () {
    super()
    this.state = { error: '' }
  }

  submit () {
    const { id, onSubmit } = this.props
    this.props.handleClose()
    if (onSubmit) {
      onSubmit(id)
    }
  }

  close () {
    if (this.props.handleClose) {
      this.props.handleClose()
    }
  }

  render () {
    const { t, isOpen, name } = this.props
    return (
      <Modal
        isOpen={isOpen}
        onRequestClose={() => this.close()}
        contentLabel='Minimal Modal Example'
        className='modal modal--auto'
        overlayClassName='signup_overlay'>
        <span onClick={() => this.close()} style={{cursor: 'pointer'}} className='ReactModal__close'><img src='/app/images/close.png' alt='' /></span>
        <p className='paragraph--centered'>{ t('common:jardiniers:confirm_chose', { name })}</p>
        <p className='paragraph--centered'>{ t('common:jardiniers:confirm_chose_only_one') }</p>
        <button onClick={() => this.close()} className='btn--lined btn--small jardinier__choice__btn'>Non</button>
        <button onClick={() => this.submit()} className='btn--default btn--small jardinier__choice__btn'>Oui</button>
      </Modal>
    )
  }
}

SelectGardenerModalComponent.propTypes = {
  isOpen: bool,
  handleClose: func,
  onSubmit: func,
  t: func,
  id: string,
  name: string
}

SelectGardenerModalComponent.defaultProps = {
  isOpen: false
}

export const SelectGardenerModal = translate()(SelectGardenerModalComponent)



// WEBPACK FOOTER //
// ./src/components/modals/SelectGardenerModal.js